import { authorize, putRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';
import { mapDataForBackend } from './mapData';

export async function adminUpdateUserAPI(user) {
  const url = `${AWS_API_URL}/admin/users/${user.userId}`;
  return putRequest(url, mapDataForBackend(user), await authorize());
}
